import { PolyfazerEnv } from "../polyfazer/PolyfazerEnv";
import manifest from "./dev-polyfazer-manifest.json";

export class DevPolyfazerEnv extends PolyfazerEnv {
	static manifest = manifest;
}

new DevPolyfazerEnv();
